import { Manager } from "../models/manager.model";

export interface ManagersState {
  managers: Array<Manager>;
}

export const initialManagersState: ManagersState = {
  managers: [],
}